import React from 'react';
import { LiFiWidget, WidgetConfig } from '@lifi/widget';

// Define the WidgetPage component
export const WidgetPage = () => {
  // Define the widget configuration using useMemo
  const widgetConfig: WidgetConfig = React.useMemo(() => ({
    containerStyle: {
      boxShadow: '1px 8px 32px rgba(0, 0, 0, 0.08)',
      borderRadius: '26px',
    },
    theme: {
      palette: {
        primary: { main: '#8761AD' },
        secondary: { main: '#8761AD' },
        background: { 
          paper: '#06070a', // bg color for cards
          default: '#141823', // bg color container
          },
        grey: {
          300: '#000000', // border light theme
          800: '#2a3142', // border dark theme
          },
      },
      shape: {
        borderRadius: 26,
        borderRadiusSecondary: 26,
      },
      typography: {
        fontFamily: 'Poppins',
      },
    },
    appearance: 'dark',
    hiddenUI: ['appearance'],
    // set source chain to Polygon
    fromChain: 137,
    // set destination chain to Optimism
    toChain: 10,
    // set source token to USDC (Polygon)
    fromToken: '',
    // set source token to USDC (Optimism)
    toToken: '',
    // set source token amount to 10 USDC (Polygon)
    fromAmount: 0,
    tokens: {
      // Featured tokens will appear on top of the list
      featured: [
        {
          address: '0x4bB5B7f0865322fD5b48D430e1a117235744769b',
          symbol: 'KITA',
          decimals: 18,
          chainId: 56,
          name: 'KITA INU',
          logoURI: 'https://kitainu.org/logo.svg',
        },
      ],
      // Include any token to the list
      include: [
        {
          address: '0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce',
          symbol: 'SHIB',
          decimals: 18,
          chainId: 1,
          name: 'Shiba Inu',
          logoURI: 'https://assets.coingecko.com/coins/images/11939/standard/shiba.png?1696511800',
        },
      ],
      // To deny a token it is required to specify the chainId and address only
      deny: [
        {
          address: '0x4200000000000000000000000000000000000006',
          chainId: 10,
        },
        {
          address: '0x0000000000000000000000000000000000000000',
          chainId: 10,
        },
      ],
    },
    // It can be either default, expandable, or drawer
    variant: 'expandable',
    // It can be either default, split, or nft
    subvariant: 'split',
  }), []); // empty dependency array to ensure useMemo runs only once

  return (
    <LiFiWidget integrator="KitaSwap" config={widgetConfig} />
  );
};

// Export the WidgetPage component as the default export
export default WidgetPage;
